export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/applause-icon.png?f4925efc152c51192b1a2cc8f7b8b803";